'use strict';

import store from './store';

const authRoute = (to, from, next) => {
  store.getters.isLoggedIn ? next() : next({name: 'welcome'});
};

export default {
  authRoute
};
